import {cn, openInNewWindow} from '@/lib/utils'
import React from 'react'

export interface IWuHelpButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  idOrSlugOrUrl: string
  size?: 'sm' | 'md'
  variant?: 'primary' | 'secondary'
}

export const WuHelpButton = React.forwardRef<
  HTMLButtonElement,
  IWuHelpButtonProps
>((props, ref) => {
  const {size = 'sm', idOrSlugOrUrl, variant = 'primary', ...rest} = props

  const fontSize = size === 'sm' ? 16 : 18
  const url = idOrSlugOrUrl.includes('http')
    ? idOrSlugOrUrl
    : `/help/${idOrSlugOrUrl}.html`

  const fillColor = variant === 'primary' ? 'text-blue-p' : 'text-gray-lead'
  return (
    <button {...rest} ref={ref} onClick={() => openInNewWindow(url)}>
      <span
        className={cn(
          'wm-help text-gray-subtle',
          `text-[${fontSize}px]`,
          fillColor,
          rest.disabled && 'text-neutral-300',
          'wu-help-button-icon',
        )}
      ></span>
    </button>
  )
})

WuHelpButton.displayName = 'WuHelpButton'
